export const ROOT_DOMAIN = "yieldfood.com";
export const APP_DOMAIN = "app.yieldfood.com";
export const LEGACY_APP_DOMAIN = "app.eip-360.com";

export const WEBSITE_URL = `https://${ROOT_DOMAIN}/`;
export const APP_URL = `https://${APP_DOMAIN}/`;

export const SUPPORT_EMAIL = `support@${ROOT_DOMAIN}`;
export const NO_REPLY_EMAIL = `no-reply@mail.${ROOT_DOMAIN}`;
